// extracted by mini-css-extract-plugin
export default {"Admin":"style_Admin__gmjuc"};